"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressFieldsByCountry = getAddressFieldsByCountry;
exports.getAddressLinesConfig = getAddressLinesConfig;
var _Button = require("../../elements/button/Button");
var _fields = require("../../form/fields");
var _restrictInput = require("../normalizers/restrictInput");
var _regex = _interopRequireWildcard(require("../regex"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getAddressLinesConfig(lines, maxLines, addAddressLineAction) {
  var allowAsciiOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return _toConsumableArray(Array(lines)).map(function (val, index) {
    var lineNumber = index + 1;

    // ATG requires shorter Address Lines 3 and 4
    var baseConfigObject = lineNumber < 3 ? _fields.ADDRESS_LINE : _fields.ADDRESS_LINE_SHORT;
    var addressLineFieldConfig = _objectSpread(_objectSpread(_objectSpread({}, baseConfigObject), {}, {
      name: "".concat(_fields.ADDRESS_LINE.name).concat(lineNumber),
      id: "".concat(_fields.ADDRESS_LINE.id).concat(lineNumber),
      autoComplete: "address-line".concat(lineNumber)
    }, allowAsciiOnly && {
      regex: (0, _regex["default"])(_regex.asciiPattern),
      normalize: _restrictInput.asciiOnly
    }), {}, {
      optional: true,
      label: "Address line ".concat(lineNumber)
    });
    if (lineNumber === 1) {
      addressLineFieldConfig.optional = false;
      addressLineFieldConfig.required = true;
    }
    if (lineNumber === lines) {
      addressLineFieldConfig.fieldExtra = _objectSpread(_objectSpread({}, _fields.ADD_ADDRESS_LINE_BUTTON), {}, {
        component: _Button.TertiaryButton,
        props: _objectSpread(_objectSpread({}, _fields.ADD_ADDRESS_LINE_BUTTON.props), {}, {
          onClick: addAddressLineAction,
          small: true
        })
      });
    }
    if (lineNumber === maxLines) {
      addressLineFieldConfig.fieldExtra = undefined;
      addressLineFieldConfig.className = 'fieldLarge';
    }
    return addressLineFieldConfig;
  });
}
function getAddressFieldsByCountry(countryCode, postcodeReadOnly) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var allowAsciiOnly = arguments.length > 3 ? arguments[3] : undefined;
  var mustContainAlphaNumerics = arguments.length > 4 ? arguments[4] : undefined;
  var enableGBCounty = arguments.length > 5 ? arguments[5] : undefined;
  var statesOrProvinces = config.statesOrProvinces,
    postcodeRequired = config.postcodeRequired,
    _config$postcodeRegex = config.postcodeRegex,
    postcodeRegex = _config$postcodeRegex === void 0 ? '' : _config$postcodeRegex,
    postcodeMaxLength = config.postcodeMaxLength;
  var states = statesOrProvinces || [];
  var stateRequired = states.length > 0;
  var postcodeRequiredRegex = new RegExp(postcodeRegex, 'i');
  var regexMaxLength = postcodeMaxLength || 10;
  var townOrCity = allowAsciiOnly ? _objectSpread(_objectSpread({}, _fields.TOWN_OR_CITY), {}, {
    regex: (0, _regex["default"])(_regex.asciiPattern),
    normalize: _restrictInput.asciiOnly
  }) : _fields.TOWN_OR_CITY;
  var stateOrCounty = allowAsciiOnly ? _objectSpread(_objectSpread({}, _fields.STATE_OR_COUNTY), {}, {
    regex: (0, _regex["default"])(_regex.asciiPattern),
    normalize: _restrictInput.asciiOnly
  }) : _fields.STATE_OR_COUNTY;
  var postcodeGB = _objectSpread(_objectSpread({}, _fields.POSTCODE_UK), {}, {
    readOnly: postcodeReadOnly,
    required: postcodeRequired,
    regex: postcodeRequiredRegex,
    maxLength: regexMaxLength
  });
  var gbFields = enableGBCounty ? [stateOrCounty, postcodeGB] : [postcodeGB];
  switch (countryCode) {
    case 'GB':
      return [_objectSpread(_objectSpread({}, townOrCity), mustContainAlphaNumerics && {
        regex: _regex.mustContainAlphaNumericsRegex,
        validationMessageKeys: _objectSpread(_objectSpread({}, _fields.TOWN_OR_CITY.validationMessageKeys), {}, {
          regex: 'Please enter a town or city'
        })
      })].concat(gbFields);
    case 'US':
      return [townOrCity, _objectSpread(_objectSpread({}, _fields.US_STATE_SELECTOR), {}, {
        options: [].concat(_toConsumableArray(_fields.US_STATE_SELECTOR.options), _toConsumableArray(states))
      }), _objectSpread(_objectSpread({}, _fields.POSTCODE), {}, {
        className: 'fieldLargeInputMedium',
        label: 'Postcode/zipcode',
        readOnly: postcodeReadOnly,
        required: postcodeRequired,
        regex: postcodeRequiredRegex,
        maxLength: regexMaxLength
      })];
    case 'CA':
      return [townOrCity, _objectSpread(_objectSpread({}, _fields.CA_PROVINCE_SELECTOR), {}, {
        options: [].concat(_toConsumableArray(_fields.CA_PROVINCE_SELECTOR.options), _toConsumableArray(states))
      }), _objectSpread(_objectSpread({}, _fields.POSTCODE), {}, {
        label: 'Postcode/zipcode',
        readOnly: postcodeReadOnly,
        required: postcodeRequired,
        regex: postcodeRequiredRegex,
        maxLength: regexMaxLength
      })];
    case 'IE':
      return [townOrCity, _objectSpread(_objectSpread({}, stateOrCounty), {}, {
        required: stateRequired,
        label: 'County/province/state'
      }), _objectSpread(_objectSpread({}, _fields.POSTCODE_IE), {}, {
        readOnly: postcodeReadOnly,
        regex: postcodeRequiredRegex,
        maxLength: regexMaxLength
      })];
    default:
      return [townOrCity, _objectSpread(_objectSpread({}, stateOrCounty), {}, {
        required: stateRequired,
        label: 'County/province/state'
      }), _objectSpread(_objectSpread({}, _fields.POSTCODE), {}, {
        label: postcodeRequired ? 'Postcode' : 'Postcode (optional)',
        readOnly: postcodeReadOnly,
        required: postcodeRequired,
        regex: postcodeRequiredRegex,
        maxLength: regexMaxLength
      })];
  }
}